import {Action} from "redux";
import {
	ContentDetail,
	DashboardSourcesEntry, DashboardTimesEntry, DashboardVisitorsEntry, Datagrid, EcommerceDetail, Keywords,
	KeywordsDetail, SourceInfo,
	Tab
} from "./app";

export const isDashboardAction = (a: Action | DashboardAction): a is DashboardAction =>
	a.hasOwnProperty("dashboard") && (a as DashboardAction).dashboard === true

export type DashboardAction = {dashboard: true} & ({
	type: "set new visitors checked"
	to: boolean
} | {
	type: "set returning visitors checked"
	to: boolean
} | {
	type: "switch tab"
	tab: Tab
} | {
	type: "set limit"
	limit: number|null
	on: Datagrid
} | {
	type: "set page"
	page: number
	on: Datagrid
} | {
	type: "set from date"
	date: Date
} | {
	type: "set to date"
	date: Date
} | {
	type: "open overview for day by id"
	dayId: number
} | {
	type: "add to keyword cache"
	dayId: number
	result: Keywords
} | {
	type: "close overview"
} | {
	type: "start obtaining dashboard data"
} | {
	type: "finished obtaining dashboard data"
	data: {
		visits: DashboardVisitorsEntry[]
		times: DashboardTimesEntry[]
		sources: DashboardSourcesEntry<number> | null
		sourcesDetail: SourceInfo[] | null
		keywordsDetail: KeywordsDetail[] | null
		contentDetail: ContentDetail[] | null
		eventDetail: ContentDetail[] | null
		ecommerce: EcommerceDetail[] | null
	}
} | {
	type: "aborted obtaining dashboard data"
})



// WEBPACK FOOTER //
// ./src/analytics/dashboard/action.ts